var map = {
	"./avatar.png": 8987,
	"./bg_image.jpeg": 2663,
	"./bg_image2.jpeg": 9100,
	"./bg_image3.jpeg": 6860,
	"./countries/belgium.webp": 8368,
	"./countries/britain.webp": 994,
	"./countries/estonia.webp": 5588,
	"./countries/france.png": 9840,
	"./countries/france.webp": 1855,
	"./countries/germany.png": 356,
	"./countries/germany.webp": 2121,
	"./countries/russia.webp": 8583,
	"./countries/usa.webp": 8668,
	"./datepicker.png": 6275,
	"./logo.webp": 7879,
	"./logo_new.png": 6583,
	"./luminor.webp": 8991,
	"./object_1.png": 6787,
	"./object_2.png": 5329,
	"./success.jpg": 6897,
	"./swedbank.webp": 3123,
	"./user_1.png": 2856,
	"./user_1_full.png": 3617,
	"./user_2.png": 7833,
	"./user_2_full.png": 371,
	"./user_3.png": 3420,
	"./user_3_full.png": 1019,
	"./user_4.png": 90,
	"./user_4_full.png": 5522,
	"./user_5.png": 3873,
	"./user_5_full.png": 7882,
	"./user_6.png": 1351,
	"./user_6_full.png": 173,
	"./user_7.png": 9678,
	"./user_7_full.png": 9425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;